export const SOCIAL_PLANNER_NAVIGATION =     {
  "name": "common.sidebar.socialPlanner",
  "meta": "social-planner",
  "icon": null,
  "enabled": true,
  "permissions": {
    "all": [
      "social_planner"
    ],
    "any": []
  },
  "items": [],
  "children": [
    {
      "name": "Dashboard",
      "meta": "social-planner-dashboard",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-dashboard-v2",
        "params": [
          "location_id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "List",
      "meta": "social-planner-list",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-settings-v2",
        "params": [
          "location_id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "Post",
      "meta": "social-planner-post",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-post-v2",
        "params": [
          "location_id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "Post Import",
      "meta": "social-planner-post-import",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-post-import-v2",
        "params": [
          "location_id",
          "id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "Post Edit",
      "meta": "social-planner-post-edit",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-post-edit-v2",
        "params": [
          "location_id",
          "id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "Planner",
      "meta": "social-planner-planner",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-planner",
        "params": [
          "location_id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "Category Queue",
      "meta": "social-planner-planner",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-category-queue",
        "params": [
          "location_id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "CSV Create",
      "meta": "social-planner-planner",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-csv-create",
        "params": [
          "location_id",
          "id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "CSV Edit",
      "meta": "social-planner-planner",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-csv-edit",
        "params": [
          "location_id",
          "id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "Content",
      "meta": "social-planner-content",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-content",
        "params": [
          "location_id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "Statistics",
      "meta": "social-planner-statistics",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-statistics",
        "params": [
          "location_id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "Social Listening",
      "meta": "social-planner-social-listening",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-social-listening",
        "params": [
          "location_id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    },
    {
      "name": "Comments",
      "meta": "social-planner-comments",
      "icon": null,
      "enabled": true,
      "permissions": {
        "all": [
          "social_planner"
        ],
        "any": []
      },
      "items": [],
      "children": [],
      "tooltip": null,
      "type": "header",
      "route": {
        "name": "social-planner-comments",
        "params": [
          "location_id"
        ]
      },
      "hide": true,
      "userScopes": {
        "any": [],
        "all": [
          "socialplanner/post.write"
        ]
      }
    }
  ],
  "tooltip": null,
  "type": "header",
  "route": {
    "name": "social-planner-dashboard-v2",
    "params": [
      "location_id"
    ]
  },
  "userScopes": {
    "any": [],
    "all": [
      "socialplanner/post.write"
    ]
  }
}
